import type { DeepLink_ConfigFragment } from '~/graphql/types';
import generateDeepLinkKey from '../generateDeepLinkKey';

type SelectedDeepLinkConfigArgs = {
  type: string | undefined;
  typeId: string | null | undefined;
};

/**
 * Returns the selected deep link config based on the type and typeId
 * @param {Array<DeepLink_ConfigFragment>} deepLinkConfigs - The deep link configs to search through
 * @param {SelectedDeepLinkConfigArgs} args - The arguments to search for
 * @returns {DeepLink_ConfigFragment | undefined} The selected deep link config
 */
const getSelectedDeepLinkConfig = (
  deepLinkConfigs: Array<DeepLink_ConfigFragment> = [],
  { type, typeId }: SelectedDeepLinkConfigArgs,
): DeepLink_ConfigFragment | undefined =>
  deepLinkConfigs.find(
    config =>
      generateDeepLinkKey(config.type, config.typeId) ===
      generateDeepLinkKey(type, typeId),
  );

export default getSelectedDeepLinkConfig;
